import React from 'react'
import Page from '../../common-components/Page';
import PaperContainer from '../../common-components/PaperContainer';
import Grid from '@material-ui/core/Grid';
// import { Typography } from '@material-ui/core';
import * as strings from '../../helpers/strings';
import { forecastData1, forecastData2 } from '../data/forecastData';
import ForecastGraph from '../forecast-view/ForecastGraph';
import ForecastFilterForm from './ForecastFilterForm';
import { Provider } from 'react-redux';
import forecastReducer from '../forecast-reducer/index';
import { createStore } from 'redux';

import ForecastGraphComponent from './ForecastGraphComponent';
import { Paper } from '@material-ui/core';

const store = createStore(forecastReducer);

const ForecastDataDisplay = () => {
  return (
    <Page title={strings.lblForecasting}>
        {/* <Typography variant="h5" color={strings.colorPrimary} title={strings.lblForecastingDataChart}>{strings.lblForecastingDataChart}</Typography> */}
        <PaperContainer>
            <Grid container spacing={16}>
                <Grid item md={2} xs={12}>
                <ForecastFilterForm/>
                    {/* <Provider store={store}>
                        <ForecastGraph forecastData1={forecastData1} forecastData2={forecastData2} />
                    </Provider> */}
                </Grid>
                <Grid item md={10} xs={12} >
                    <ForecastGraphComponent />
                </Grid>
            </Grid>
        </PaperContainer>
    </Page>
  )
}

export default ForecastDataDisplay